import { MutationFunctionOptions } from '@apollo/client';
import { ExecutionResult } from 'graphql/execution';
import { IAfterPostSave } from '../components/connectedForm/useManagedSubmit';

//FormType - Type of the entity on the form, e.g. 'IEvent', 'IProduct', etc.
export type IConnectedFormProps<FormType = any> = {
  formUpdate?: (options?: MutationFunctionOptions | undefined) => Promise<ExecutionResult<any>>;
  formTemporaryUpdate?: (options?: MutationFunctionOptions | undefined) => Promise<ExecutionResult<any>>;
  formData: {
    defaultRecord?: FormType;
    data?: FormType;
    isDefault: boolean;
    [key: string]: any;
  };
  defaultSaveOption?: { value: 'CONTINUE' | 'EXIT' | 'NEW' };
  forceUpdate?: boolean; //Not recommended - Avoid or find other workaround where possible.
  postSaveFunction?: IAfterPostSave;
  readOnly?: boolean;
  onClose?: (result?: any) => void; //Includes a result only when we exit via successful save - Otherwise expect undefined.
  modalClose?: boolean;
};

export enum SubmitOption {
  Exit = 'EXIT',
  Continue = 'CONTINUE',
  New = 'NEW',
}
